import styled from 'styled-components/macro';

const PillWrapper = styled.div`
	display: flex;
	align-items: center;
`;

export default PillWrapper;
